module.exports = __webpack_public_path__ + "img/122.5.f965a753.png";